module.exports = __webpack_public_path__ + "media/images/arrow-f9ceff76168b7bec4a644121347d973b.svg";